module.exports = __webpack_public_path__ + "img/icon_fail_small@2x.eaf870d3.png";